<script lang="ts">
  import { Icon } from "@lernetz/svelte-icon";
  //import { setupData } from "../services";

  export let title: string;
  export let setup: any;

  //console.log(setup)

  //setupData(setup);
</script>

<svelte:head>
  <title>{title}</title>
</svelte:head>

<h1 class="font-bold text-24 flex items-center gap-x-8">
  <Icon width="24" height="24" name="home"></Icon>
  <span>My Demopage</span>
</h1>
